<div class="curva-abc-venda">
    <div class="container-header">
        <nav class="container-header-block container-header-breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">Curva ABC de Vendas</li>
            </ol>
        </nav>
        <div class="container-header-block container-header-referencia-filter">
            <sgt-curva-abc-venda-referencia-select
                [(idReferencia)]="filter.idReferencia"
                [(referencia)]="filter.referencia"
                [isShowTitle]="true"
                [isShowNull]="false"
                (afterInitialized)="filterInitialization.initializeReferencia()"
                (afterSelect)="onFilterChange()">
            </sgt-curva-abc-venda-referencia-select>
        </div>
        <div class="container-header-block container-header-options">
            <div class="btn-group mr-2">
                <button type="button" class="btn btn-light dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Opções
                </button>
                <div class="dropdown-menu">
                    <a class="dropdown-item" (click)="openReportModal()">
                        <i class="fas fa-print" aria-hidden="true"></i> Imprimir
                    </a>                                    
                    <a class="dropdown-item" (click)="openExcelExportModal()">
                        <i class="far fa-file-excel"></i> Exportar para Excel
                    </a>                                    
                </div>
            </div>  
        </div>
    </div>
    <div class="container-filter">
        <sgt-curva-abc-venda-filter
            #filterComponent
            [filterStorageKey]="filterStorageKey"
            [isShowClienteFilter]="!idPessoaFilter"
            [filter]="filter"
            [initialization]="filterInitialization"
            (filterChange)="onFilterChange()"
            (filterCleaned)="onFilterCleaned()">
        </sgt-curva-abc-venda-filter>
    </div>
    <div class="container-content">
        <sgt-curva-abc-venda-perspectiva-nav
            #perspectivaNav
            [filter]="filter"
            [filterStorageKey]="filterStorageKey">
        </sgt-curva-abc-venda-perspectiva-nav>
    </div>
</div>

<sgt-curva-abc-venda-report-modal
    #reportModal>
</sgt-curva-abc-venda-report-modal>

<sgt-curva-abc-venda-excel-export-modal
    #excelExportModal>
</sgt-curva-abc-venda-excel-export-modal>